// extracted by mini-css-extract-plugin
export default {"storesContainer":"Stores_storesContainer__YK+8G","header":"Stores_header__ELESj","actionButtons":"Stores_actionButtons__2lA+N"};